import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage/LandingPage';

const AppRoutes: React.FC = () => (
    <Routes>
        <Route path="/" element={<LandingPage />} />
    </Routes>
);

export default AppRoutes;

